import * as React from 'react'
import * as styles from './RatingOverlay.module.scss'
import { ItemMaturityRating } from 'DVWebNodeUtils';

interface RatingOverlayProps {
  ratingObj: ItemMaturityRating
}

const RatingOverlay = ({ ratingObj }: RatingOverlayProps) => {
  if (ratingObj && ratingObj.rating) {
    return <div className={styles.RatingOverlay}>
      <span className={styles.RatingText}>{ratingObj.rating}</span>
    </div>
  }
  return null
}

export default RatingOverlay
